import { observer } from 'mobx-react-lite';

import { EntireScreenButton } from '@gem/call/components/EntireScreenButton/EntireScreenButton';
import { ShareScreenButton } from '@gem/call/components/ShareScreenButton/ShareScreenButton';
import {
  IcMicOffIcon,
  IcMicOnIcon,
  IcMinimizeIcon,
  IcVideoOffIcon,
  IcVideoOnIcon,
} from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { ExternalLink, IconButton } from '@gem/ui-kit';

import ThreadButton from '../../SharedComponents/ThreadButton';
import styles from './styles.m.css';

const ControlPanel = ({ presenter, streamerPresenter, isCommentsHidden }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      {presenter.isMeStreamer && (
        <>
          <IconButton
            Icon={streamerPresenter.audioMuted ? IcMicOffIcon : IcMicOnIcon}
            onClick={
              streamerPresenter.audioMuted
                ? streamerPresenter.unmuteAudio
                : streamerPresenter.muteAudio
            }
            className={styles.button}
            size="large"
            iconSize="medium"
            theme={streamerPresenter.audioMuted ? 12 : 13}
          />
          <IconButton
            Icon={streamerPresenter.isVideoMuted ? IcVideoOffIcon : IcVideoOnIcon}
            onClick={
              streamerPresenter.videoMuted
                ? streamerPresenter.unmuteVideo
                : streamerPresenter.muteVideo
            }
            className={styles.button}
            size="large"
            iconSize="medium"
            theme={streamerPresenter.videoMuted ? 12 : 13}
          />
          <ShareScreenButton
            className={styles.button}
            isActive={streamerPresenter.isSharedScreen}
            shareScreen={streamerPresenter.startSharingScreen}
            stopSharingScreen={streamerPresenter.stopSharingScreen}
          />
        </>
      )}
      <div className={styles.right}>
        {presenter.donationUrl && !presenter.isMeStreamer && (
          <ExternalLink
            className={styles.donateButton}
            href={presenter.donationUrl}
            theme="fixed-color"
          >
            {t('channel_donate')}
          </ExternalLink>
        )}
        {!isCommentsHidden && (
          <ThreadButton
            className={styles.button}
            onClick={presenter.collapse}
          />
        )}
        {presenter.isStreamStarted ? (
          <IconButton
            Icon={IcMinimizeIcon}
            onClick={presenter.collapse}
            className={styles.button}
            size="large"
            iconSize="medium"
            theme="12"
          />
        ) : null}
        <EntireScreenButton className={styles.button} />
      </div>
    </div>
  );
};

export default observer(ControlPanel);
